export type DuplicateTarget = 'same' | 'unassigned' | 'other';

export type DuplicateSource = {
  workoutId: number;
  programId: number | null;
};

export type DuplicateDialogProps = {
  influencerId: number;
  sourceProgramId: number;
  onConfirm: (targetProgramId: number | undefined) => void;
  onClose: () => void;
};

export const toDuplicateTarget = (value: string): DuplicateTarget =>
  value === 'unassigned' || value === 'other' ? value : 'same';

export const resolveTargetProgramId = (
  target: DuplicateTarget,
  sourceProgramId: number,
  otherProgramId: number | null,
): number | undefined => {
  switch (target) {
    case 'same':
      return sourceProgramId;
    case 'other':
      return otherProgramId ?? undefined;
    case 'unassigned':
      return undefined;
  }
};
